export function closestElement(selector: string, base: Element = this) {
  function __closestFrom(el: Element | Window | Document): Element {
    if (!el || el === document || el === window) return null;
    if ((el as HTMLSlotElement).assignedSlot)
      el = (el as HTMLSlotElement).assignedSlot;
    const found = (el as Element).closest(selector);
    return found
      ? found
      : __closestFrom(((el as Element).getRootNode() as ShadowRoot).host);
  }
  return __closestFrom(base);
}

/**
 * Get direct child elements / nodes from from any element (for when querySelectorAll(':scope > .selector') fails)
 * @param el - a root element to query from
 * @param sel - a query selector string
 * @param elesOnly - return only Elements (no Nodes)
 */
export function getDirectChildren<T = HTMLElement>(
  el: Element,
  sel: string,
  elesOnly?: true
): Array<T>;
export function getDirectChildren<T = HTMLElement>(
  el: Element,
  sel: string,
  elesOnly?: 'slot'
): Array<T>;
export function getDirectChildren<T = HTMLElement>(
  el: Element,
  sel: string,
  elesOnly?: false
): Array<T | Node>;
export function getDirectChildren<T = HTMLElement>(
  el: Element,
  sel: string,
  elesOnly: boolean | 'slot' = true
) {
  if (elesOnly === true) {
    try {
      sel = ':scope > ' + sel.split(',').join(', :scope >');
      return Array.from(el.querySelectorAll(sel)) as unknown as Array<T>;
    } catch (e) {
      console.log('an error sad');
    }
  }
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  const ret: Array<Node | T> = [];
  Array.from(el.childNodes).forEach((e) => {
    if (!!(e as Element).matches && (e as Element).matches(sel)) ret.push(e);
    else if (e.nodeName.toLowerCase() === 'slot') {
      Array.from((e as HTMLSlotElement).assignedNodes()).forEach((slotEl) => {
        if (slotEl instanceof Element && slotEl.matches(sel)) ret.push(slotEl);
        else if (slotEl instanceof Node && !elesOnly) ret.push(slotEl as Node);
      });
    } else if (!elesOnly) ret.push(e as Node);
  });
  return ret;
}

export const getSiblings = <T extends Element>(
  el: Element,
  sel?: string
): Array<T> => {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }
  const siblings = [];
  let firstChild = el.parentNode.firstElementChild;
  do {
    if (!sel || (firstChild !== el && firstChild.matches(sel)))
      siblings.push(firstChild);
  } while ((firstChild = firstChild.nextElementSibling));
  return siblings;
};

export function getOffset(element: HTMLElement, parent: HTMLElement) {
  if (!parent || !element) return;
  return {
    top:
      element.getBoundingClientRect().top - parent.getBoundingClientRect().top,
    left:
      element.getBoundingClientRect().left -
      parent.getBoundingClientRect().left,
  };
}
